<template>
  <div style="margin: 2% 3% 0% 3%;">
    <v-card color="border" elevation="3" style="padding: 20px 20px 0px 20px;">
      <v-tooltip open-delay="2000" location="top">
        <template v-slot:activator="{ props }">
          <v-autocomplete 
            v-bind="props"
            @keydown.enter.prevent="selectCloseFromClosesView()"
            v-model="input.localityID"
            :append-inner-icon="input.localityID.length == 0 ? 'mdi-store' : 'mdi-store-off'" 
            @click:append-inner="input.localityID.length = 0; this.blurInput('localityID')"
            :items="display.localityOptions" 
            :loading="loader.localityOptions" 
            :disabled="loader.localityOptions"
            multiple
            chips
            closable-chips
            color="primary"
            ref="localityID"
            item-title="localityName" 
            item-value="localityID" 
            label=" Filtrar por localidad"
            placeholder="Todas las localidades"
            variant="solo-filled" 
            density="compact"
          ></v-autocomplete>
        </template>
        <span style="max-width: 400px; display: block;">La localidad es el lugar desde donde se contiene el inventario del producto. Este espacio permite selección múltiple para filtrar por varias localidades en paralelo. Si ninguna localidad es seleccionada, se buscarán todos inventarios sin importar la localidad. Al presionar el ícono de la derecha se limpian las localidades seleccionadas</span>
      </v-tooltip>
      <v-tooltip open-delay="2000" location="top">
        <template v-slot:activator="{ props }">
          <v-autocomplete 
            v-bind="props"
            v-model="input.productID" 
            v-model:search="input.searchedProductID"
            :append-inner-icon="input.productID ? 'mdi-alphabetical-variant-off' : 'mdi-alphabetical-variant'" 
            @click:append-inner="cleanProductIDInput()" 
            :items="display.productOptions" 
            :loading="loader.selectProductBasicBasicInformationForBillsView || loader.selectProductStockOnProductStockView" 
            :disabled="loader.selectProductBasicBasicInformationForBillsView || loader.selectProductStockOnProductStockView" 
            @keydown.enter.prevent="selectProductByScanner()"
            ref="productID" 
            item-title="productAutocompleteTitle" 
            item-value="productID" 
            label="Filtrar por producto" 
            placeholder="Todos los productos" 
            variant="solo-filled" 
            density="compact"
          ></v-autocomplete>
        </template>
        <span style="max-width: 400px; display: block;">Este espacio permite la búsqueda o escaneo de un producto. Si ningún producto es seleccionado, se buscarán todas las facturas sin importar los productos facturados en las mismas. Al presionar el ícono de la derecha se limpia el producto seleccionado</span>
      </v-tooltip>
    </v-card>
    <br><br>
    <v-card v-if="display.productStock.length > 0" color="border" elevation="3" style="padding: 20px;">
      <v-data-table :headers="display.productStockHeaders" :items="display.productStock" :items-per-page="250" style="max-height: 700px; overflow-y: auto;">
        <template v-slot:item.productAction="{ item }">
          <div style="display: flex;">
            <v-tooltip :text="`Ranking de producto histórico${item.productRanking == 'NA' ? ' (sin ventas registradas)' : ''}`" location="top">
              <template v-slot:activator="{ props }">
                <v-chip v-bind="props" v-if="accessCredential['/product']" color="purple" label style="margin-right: 10px; font-size: small; font-weight: bold; cursor: pointer;">
                  <v-icon icon="mdi-medal" start></v-icon>
                  <p>{{ item.productRanking }}</p>
                </v-chip>
              </template>
            </v-tooltip>
            <v-tooltip text="Panel de producto" location="top">
              <template v-slot:activator="{ props }">
                <v-chip v-bind="props" v-if="accessCredential['/product']" color="warning" label style="margin-right: 10px; font-size: small; font-weight: bold;  cursor: pointer;">
                  <v-icon @click="$generalFunctions.default.methods.openNewTab('/product/'+item.productID)" icon="mdi-bulletin-board"></v-icon>
                </v-chip>
              </template>
            </v-tooltip>
            <v-tooltip text="Tracking de producto" location="top">
              <template v-slot:activator="{ props }">
                <v-chip v-bind="props" v-if="accessCredential['/productHistory']" color="indigo" label style="font-size: small; font-weight: bold; cursor: pointer;">
                  <v-icon @click="$generalFunctions.default.methods.openNewTab('/productHistory/'+item.productID)" icon="mdi-update"></v-icon>
                </v-chip>
              </template>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:item.productName="{ item }">
          <div style="width: 350px;">
            <p>{{ item.productName }}</p>
            <p><strong>{{ item.productID }}</strong></p>
          </div>
        </template>
        <template v-slot:item.productStock="{ item }">
          <div style="display: flex">
            <div v-for="productStockByLocality in item.productStock" v-bind:key="productStockByLocality">
              <v-tooltip :text="productStockByLocality.localityName" location="top">
                <template v-slot:activator="{ props }">
                  <v-chip v-bind="props" :color="productStockByLocality.localityColor" variant="flat" style="margin: 0px 5px 0px 5px; cursor: pointer;">
                    <p :style="{color: productStockByLocality.localityFontColor}" style="font-size: x-large;"><strong>{{ productStockByLocality.productStockAmount }}</strong></p>
                  </v-chip>
                </template>
              </v-tooltip>
            </div>
            <div v-if="input.localityID.length != 1">
              <v-tooltip :text="(input.localityID.length != 0 && input.localityID.length != display.localityOptions.length) ? 'TOTAL (de las localidades seleccionadas)' : 'TOTAL'" location="top">
                <template v-slot:activator="{ props }">
                  <v-chip v-bind="props" color="black" variant="flat" style="margin: 0px 5px 0px 5px; cursor: pointer;">
                    <p style="color: white; font-size: x-large;"><strong>{{ item.productStockTotal }}</strong></p>
                  </v-chip>
                </template>
              </v-tooltip>
            </div>
          </div>
        </template>
      </v-data-table>
    </v-card>
    <br><br>
  </div>
</template>

<style scoped>
  .fadeOut {
    animation: fadeOutAnimation 30s forwards;
  }
  @keyframes fadeOutAnimation {
    0% {
      opacity: 1;
    }
    70% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
</style>

<script>
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'productStockCheckView',
  inject: ['$generalFunctions'],

  data: () => ({
    input: 
    {
      localityID: [],
      productID: null,
      searchedProductID: null
    },

    display: 
    {
      localityOptions: [],
      productOptions: [],      
      productStockHeaders: 
      [
        {key: 'productAction', title: null, sortable: false},
        {key: 'productName', title: 'PRODUCTO', sortable: false},
        {key: 'productStock', title: 'STOCK', sortable: false}
      ],
      productStock: []
    },

    navigation: {},

    loader:
    {
      selectLocalityIDAndLocalityName: false,
      selectProductBasicBasicInformationForBillsView: false,
      selectProductStockOnProductStockView: false
    },

    localStorage:
    {
      localityID: null,
      agentID: null
    },

    accessCredential: {}
  }),

  watch: {
    'input.productID': function(){
      if (this.input.productID != null){
        this.selectProductStockOnProductStockView();
      }
    },

    'input.localityID': function(){
      if (this.input.productID != null){
        this.selectProductStockOnProductStockView();
      }
    }

  },

  methods: {
    async selectProductStockOnProductStockView(){
      this.loader.selectProductStockOnProductStockView = true;
      this.display.productStock.length = 0;
      const selectProductStockOnProductStockViewRequestQuery =
      {
        'localityID': this.input.localityID,
        'productID': this.input.productID,
        'productCategoryID': [],
        'productBrandID': [],
        'productModelID': [],
        'productFlavorID': [],
        'productNicotineLevelID': [],
        'productSizeID': []
      };
      const selectProductStockOnProductStockViewResult = await this.$generalFunctions.default.methods.executeHttpPostRequest('/product/productStock/functions/selectProductStockOnProductStockView', selectProductStockOnProductStockViewRequestQuery);
      if (selectProductStockOnProductStockViewResult.success){
        this.display.productStock = selectProductStockOnProductStockViewResult.result.map(productRow => ({
          ...productRow,
          'productStockTotal': productRow.productStock.reduce((productStockTotal, productStockByLocality) => productStockTotal + productStockByLocality.productStockAmount, 0)
        }));
        this.navigation.searchVisible = '';
        if (this.display.productStock.length == 0) {
          this.$root.notificationDialog.showNotificationDialog({
            'notificationDialogTitle': 'ATENCIÓN',
            'notificationDialogBody': 'No se ha encontrado ningún producto con los filtros seleccionados, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema',
            'notificationDialogColor': 'warning',
            'notificationDialogIsPersistent': false
          });
        }
      } else {
        this.$root.notificationDialog.showNotificationDialog({
          'notificationDialogTitle': 'ERROR',
          'notificationDialogBody': 'Ha ocurrido un error inesperado al consultar los productos, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema',
          'notificationDialogColor': 'error',
          'notificationDialogIsPersistent': false
        });
      }
      this.loader.selectProductStockOnProductStockView = false;
    },

    async selectLocalityIDAndLocalityName(){
      this.loader.selectLocalityIDAndLocalityName = true;
      const selectLocalityIDAndLocalityNameResult = await this.$generalFunctions.default.methods.executeHttpPostRequest('/locality/select/localityIDAndLocalityName');
      if (selectLocalityIDAndLocalityNameResult.success){
        this.display.localityOptions = selectLocalityIDAndLocalityNameResult.result;
      } else {
        this.$root.notificationDialog.showNotificationDialog({
          'notificationDialogTitle': 'ERROR',
          'notificationDialogBody': 'Ha ocurrido un error inesperado al consultar las localidades, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema',
          'notificationDialogColor': 'error',
          'notificationDialogIsPersistent': false
        });
      }
      this.loader.selectLocalityIDAndLocalityName = false;
    },

    async selectProductBasicBasicInformationForBillsView(){
      this.loader.selectProductBasicBasicInformationForBillsView = true;
      const selectProductBasicBasicInformationForBillsViewResult = await this.$generalFunctions.default.methods.executeHttpPostRequest('/product/functions/selectProductBasicBasicInformationForBillsView');
      if (selectProductBasicBasicInformationForBillsViewResult.success){
        this.display.productOptions = selectProductBasicBasicInformationForBillsViewResult.result.map(productOption => ({
          'productID': productOption.i,
          'productSKU': productOption.s,
          'productName': productOption.n,
          'productAutocompleteTitle': productOption.s + ' - ' + productOption.n
        }));
        this.loader.selectProductBasicBasicInformationForBillsView = false;
      } else {
        this.$root.notificationDialog.showNotificationDialog({
          'notificationDialogTitle': 'ERROR',
          'notificationDialogBody': 'Ha ocurrido un error inesperado al consultar la lista de productos, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema',
          'notificationDialogColor': 'error',
          'notificationDialogIsPersistent': false
        });
      }
    },

    selectProductByScanner(){
      const selectedProduct = this.display.productOptions.find(productOption => productOption.productID == this.input.searchedProductID);
      if (selectedProduct){
        this.blurInput('productID');
        this.input.productID = selectedProduct.productID;
      } else {
        this.$root.notificationDialog.showNotificationDialog({
          'notificationDialogTitle': null,
          'notificationDialogBody': 'El producto escaneado no ha sido encontrado, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema',
          'notificationDialogColor': 'warning',
          'notificationDialogIsPersistent': false
        });
      }
    },

    cleanProductIDInput(){
      this.input.searchedProductID = null;
      this.input.productID = null;
      this.blurInput('productID');
    },

    blurInput(inputReference){
      const blurInputInterval = setInterval(() => {
        if (this.$refs[inputReference]) {
          this.$refs[inputReference].blur();
          clearInterval(blurInputInterval);
        }
      }, 1);
    },

    setDefaultValues(){
      this.input.localityID.length = 0;
      this.input.productID = null;
      this.display.productStock.length = 0;
    },
    
    async getLocalStorageData(){
      this.localStorage.localityID = localStorage.getItem('localityID');
      this.localStorage.agentID = localStorage.getItem('agentID');
      this.accessCredential = await this.$generalFunctions.default.methods.validateCredentialAccess(this.localStorage.agentID);
    },

  },

  async mounted(){
    await this.getLocalStorageData();
    this.selectLocalityIDAndLocalityName();
    this.selectProductBasicBasicInformationForBillsView();
  }
});
</script>
